import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'

const menuPermission = new RestResource({server: ORGANIZATION_SERVER, resource: 'menuPermission'});

export default menuPermission;